import React from 'react';
interface ServicePlanProps {
  title: string;
  price: string;
  description: string;
  imageUrl: string;
  imageAlt: string;
  buttonText?: string;
  paymentLink?: string;
}
export const ServicePlan = ({
  title,
  price,
  description,
  imageUrl,
  imageAlt,
  buttonText = 'Purchase Plan',
  paymentLink = '#'
}: ServicePlanProps) => {
  return <div className="bg-white rounded-lg shadow-md overflow-hidden transition-transform hover:shadow-lg hover:-translate-y-1" data-id="element-157">
      <div className="h-48 overflow-hidden" data-id="element-158">
        <img src={imageUrl} alt={imageAlt} className="w-full h-full object-cover" data-id="element-159" />
      </div>
      <div className="p-6" data-id="element-160">
        <h3 className="text-xl font-bold text-primary mb-2" data-id="element-161">{title}</h3>
        <div className="text-2xl font-bold text-secondary mb-4" data-id="element-162">{price}</div>
        <p className="text-gray-600 mb-6" data-id="element-163">{description}</p>
        <a href={paymentLink} className="block w-full bg-secondary hover:bg-secondary/90 text-white font-bold py-3 px-4 rounded-md text-center transition-colors" data-id="element-164">
          {buttonText}
        </a>
      </div>
    </div>;
};